import React from 'react'
import './Information.css'

const Information = () => {
	const scroll = () => {
		const contact = document.getElementById('contact')
		if (contact) contact.scrollIntoView({ behavior: 'smooth' })
	}

	return (
		<section className='information-section'>
			<div className='information-inner text-block'>
				<div className='cta-card'>
					<div className='cta-card-bg' aria-hidden='true'>
						<img src='/assets/images/motorcycle-brands.jpg' alt='' />
						<div className='cta-card-overlay'></div>
					</div>
					<div className='cta-card-content'>
						<span className='cta-eyebrow'>Ready to ride?</span>
						<h2 className='cta-title'>
							Our experienced technicians are dedicated to keeping your ride
							on the road.
						</h2>
						<p className='cta-sub'>
							Achieve your performance goals with the team that treats every
							build like its own.
						</p>
						<button className='cta-btn' onClick={scroll}>
							Contact Us Today
							<svg
								width='18'
								height='18'
								viewBox='0 0 24 24'
								fill='none'
								stroke='currentColor'
								strokeWidth='2.4'
								strokeLinecap='round'
								strokeLinejoin='round'
							>
								<line x1='5' y1='12' x2='19' y2='12'></line>
								<polyline points='12 5 19 12 12 19'></polyline>
							</svg>
						</button>
					</div>
				</div>
			</div>
		</section>
	)
}

export default Information
